<!-- <mat-card *ngFor="let error of error.messages | async" color="warn" class="error-message">
    {{error.message}}
</mat-card> -->

<div class="common-pad03">
    <h1 color="primary">This page cannot be displayed</h1>
    <p>We've encountered a problem trying to display this page. Try going back to the previous page or use the
        navigation menu.</p>
    <p>For more information, please contact support.</p>

    <h3 *ngFor="let error of messages">
        Error Code {{error.code}}: {{error.message}}
    </h3>
    <ng-container *ngIf="processId">
        <h4>Process ID: {{processId}}</h4>
    </ng-container>

    <button mat-raised-button color="primary" routerLink="/">Back to Home</button>
</div>
